import * as React from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { ApplicationForm } from "../../components/jobs/application-form"
import { jobs } from "../../contents/job/jobs"
import { Conditions } from "../../components/jobs/conditions"
import { Flow } from "../../components/jobs/flow"
import { Hr } from "../../components/jobs/hr"
import { JobItemSmall } from "../../components/jobs/jobItemSmall"
import { Layout } from "../../components/layout"
import { Head } from "../../components/seo"

export const EmploymentPage = () => {
  const { t, i18n } = useTranslation("translations", { keyPrefix: "EMPLOYMENT" })

  const openJobs = jobs.filter(i => i.active)
  const closedJobs = jobs.filter(i => !i.active)

  return (
    <Layout title="RECRUIT" subtitle={t("SUBTITLE")}>
      <Head title="RECRUIT" />
      <Container className="text-center my-4">
        <Row>
          <Col md="12" className="my-4">
            <h3>{t("FOR_APPLICANTS.TITLE")}</h3>
            <Hr />
            <div>
              {[1, 2, 3, 4, 5, 6, 7].map((i) => {
                const key = `FOR_APPLICANTS.${i}`
                const message = t(key)
                if (message === key) return null
                return <p key={i}>{message}</p>
              })}
            </div>
          </Col>

          {openJobs.length > 0 && <Col md="12" className="mt-5 mb-4">
            <h3>{t("POSITIONS.OPEN_TITLE")}</h3>
            <Hr />
          </Col>}
          {openJobs.map((job) => (
            <Col xl="4" lg="6" className="animation-slide-in text-start mb-4 animation-on-cursor" key={job.slug}>
              <JobItemSmall job={job} />
            </Col>
          ))}
          {closedJobs.length > 0 && <Col md="12" className="mt-5 mb-4">
            <h3>{t("POSITIONS.CLOSE_TITLE")}</h3>
            <Hr />
          </Col>}
          {closedJobs.map((job) => (
            <Col xl="4" lg="6" className="animation-slide-in text-start mb-4" key={job.slug}>
              <JobItemSmall job={job} />
            </Col>
          ))}
          <Flow />
          <Conditions />
        </Row>
      </Container>
      <ApplicationForm />
    </Layout>
  )
}
